


import {Component, Emit, Model, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class AppSwitch extends Vue {

  @Prop({default: false})
  public disabled!: boolean;

  @Prop({default: ''})
  public label!: string;

  @Model('change', {default: false})
  public value!: boolean;

  @Emit('change')
  public emitChange() {
    return this.isChecked;
  }

  private isChecked: boolean = false;

  public mounted(): void {
    this.isChecked = this.value;
  }

  private toggle(): void {
    if (!this.disabled) {
      this.isChecked = !this.isChecked;
      this.emitChange();
    }
  }
}
